import React from "react";
import "./App.css";
import { Route, Routes, useLocation } from "react-router-dom";
import {
  Layout,
  Home,
  ContactUs,
  Product,
  AboutUs,
  Investors,
  CodeNPolicies,
  PaperAds,
  Notice,
  PreIssueAdvertisment,
} from "./Pages";
import AnnualReturn from "./Pages/InvestorsSub/AnnualReturn";
import ShareholdingPattern from "./Pages/InvestorsSub/ShareholdingPattern";
import PressRelease from "./Pages/InvestorsSub/PressRelease";
import NoticeOfBoardMeeting from "./Pages/InvestorsSub/NoticeOfBoardMeeting";
import ScrutinizerReport from "./Pages/InvestorsSub/ScrutinizerReport";
import FinancialResults from "./Pages/InvestorsSub/FinancialResults";
import AnnualReport from "./Pages/InvestorsSub/AnnualReport";
import ClosureOfTradingWindow from "./Pages/InvestorsSub/ClosureOfTradingWindow";

function App() {
  let location = useLocation();
  let path = location?.pathname;
  return (
    <div>
      <Routes>
        <Route exact path="/" element={<Layout />}>
          <Route index element={<Home />} />
          <Route path="about-us" element={<AboutUs />} />
          <Route path="products" element={<Product />} />
          <Route path="investors" element={<Investors />} />
          <Route path="code-and-policies" element={<CodeNPolicies />} />
          <Route path="paper-ad" element={<PaperAds />} />
          <Route
            path="pre-issue-advertisment"
            element={<PreIssueAdvertisment />}
          />
          <Route path="notices" element={<Notice />} />
          <Route path="annual-return" element={<AnnualReturn />} />
          <Route path="shareholding-pattern" element={<ShareholdingPattern />} />
          <Route path="press-release" element={<PressRelease />} />
          <Route
            path="notice-of-board-meeting"
            element={<NoticeOfBoardMeeting />}
          />
          <Route path="scrutinizer-report" element={<ScrutinizerReport />} />
          <Route path="financial-results" element={<FinancialResults />} />
          <Route path="annual-report" element={<AnnualReport />} />
          <Route path="closure-of-trading-window" element={<ClosureOfTradingWindow />} />
          <Route path="/public/*" element={null} />

          <Route path="contact-us" element={<ContactUs />} />
        </Route>
        <Route
          path="*"
          element={
            <h1
              style={{
                justifyContent: "center",
                display: "flex",
                marginTop: 200,
              }}
            >{`${path} This page is Not Found!`}</h1>
          }
        />
      </Routes>
    </div>
  );
}

export default App;
